import React, { useCallback, useEffect, useState } from "react";
import {
  handleHoldedCards,
  handleWinCard,
} from "./helperFunctions/cardHandlers";
import {
  CardContainer,
  CardWrapper,
  RotatableCard,
  Cardback,
  CardFront,
  ApearableCard,
} from "./CardsStyled";
import { CARDS_PROPS } from "./interface";
import { useCard } from "@orbital/games-frontend-library";
import { colors } from "../../../lib/colors";
import useStateHandler from "./helperFunctions/stateHandlers";
// import initSFX from "../../../assets/audio/cardFlipSFX.mp3";
// import initsSFX from "../../../assets/audio/cardFlip3SFX.mp3";
// import useSound from "use-sound";

export default function Cards({
  stateRound,
  holded,
  setHolded,
  audioUrl,
  cleared,
  clearAnim,
  cardFront,
  handleLastCardRotate,
  lastCardRotated,
  isLoaded,
}: CARDS_PROPS) {
  const time = 835;

  const { cards, winPositions, state } = stateRound;
  const { cardAnim } = useStateHandler(state, time, clearAnim);
  const [dealedCards, setDealedCards] = useState<any>(cards);
  const [selected, setSelected] = useState<any>([]);
  const [cardClick, setCardClick] = useState<any>(null);
  const [delayArr, setdelayArr] = useState<any[]>([0, 1, 2, 3, 4]);
  const [initialCardAnim, setinitialCardAnim] = useState(false);

  const { handleCardSymbol, handleCardColor, handleCardSuit } = useCard();

  useEffect(() => {
    !cards || cards.length <= 1
      ? setDealedCards(["", "", "", "", ""])
      : setDealedCards(cards);
  }, [cards]);

  const handleInitial = useCallback(() => {
    if (cleared) {
      setSelected([]);
      setHolded([0, 0, 0, 0, 0]);
      setdelayArr([0, 1, 2, 3, 4]);
    }
  }, [cleared, setHolded]);

  useEffect(() => {
    handleInitial();
  }, [handleInitial]);

  useEffect(() => {
    if (isLoaded && state === 1) {
      setinitialCardAnim(true);
      setTimeout(() => {
        setinitialCardAnim(false);
      }, 918);
    }
  }, [isLoaded, state]);

  const [isClickable, setIsClickable] = useState<boolean>(false);

  useEffect(() => {
    if (state === 2 && lastCardRotated) {
      setIsClickable(true);
    } else {
      setIsClickable(false);
    }
  }, [state, lastCardRotated]);

  const handleCardClick = (i: number) => {
    if (isClickable) {
      handleHoldedCards(i, holded, setHolded, selected, setSelected);
      setCardClick(i);
      setIsClickable(false);
      setTimeout(() => {
        setIsClickable(true);
      }, 400);
      audioUrl.hold();
      getDelayArr();
    }
  };

  const getDelayArr = () => {
    let a = 0;
    let arr: any[] = [0, 0, 0, 0, 0];
    for (let i = 0; i < 5; i++) {
      if (holded[i] === 0) {
        arr[i] = a;
        a++;
        setdelayArr(arr);
      } else {
        arr[i] = 0;
        setdelayArr(arr);
      }
    }
  };

  useEffect(() => {
    if (cardFront) {
      setTimeout(() => {
        handleLastCardRotate(true);
      }, 918);
    }
  }, [cardFront, handleLastCardRotate]);

  // const [playInitSFX] = useSound(initSFX, {
  //   volume: 0.5,
  // });
  // const [playInitsSFX] = useSound(initsSFX, {
  //   volume: 0.5,
  // });
  // useEffect(() => {
  //   if (state === 2 && !cardFront) {
  //     playInitsSFX();
  //   }
  // }, [cardFront, state, playInitsSFX]);
  return (
    <CardContainer>
      {dealedCards &&
        dealedCards.map((card: any, index: any) => (
          <ApearableCard
            childNumber={index}
            key={index}
            cleared={clearAnim}
            initialCardAnim={initialCardAnim}
            // onAnimationStart={() =>
            //   initialCardAnim && state === 1 && playInitSFX()
            // }
          >
            <RotatableCard
              onClick={() => handleCardClick(index)}
              rotateCard={!cardFront && !selected.includes(index)}
            >
              <CardWrapper
                childNumber={cardFront ? delayArr[index] : 0}
                cleared={clearAnim}
                onAnimationEnd={() => {
                  setCardClick(null);
                }}
                className={
                  selected.includes(index) ? "hold card" : "card rotatable"
                }
                holdAnim={cardClick === index}
              >
                <Cardback className="back" />
                <CardFront
                  winColor={
                    lastCardRotated && handleWinCard(index, winPositions)
                  }
                  className="front"
                  showContent={cardAnim}
                  cleared={clearAnim}
                  suitColor={card && handleCardColor(
                    card,
                    colors.secondaryText,
                    colors.secondaryBackground
                  )}
                  isClickable={isClickable}
                >
                  <p>{card && handleCardSymbol(card)}</p>
                  {card && handleCardSuit(card)}
                </CardFront>
                <h3>HOLD</h3>
              </CardWrapper>
            </RotatableCard>
          </ApearableCard>
        ))}
    </CardContainer>
  );
}
